(function () {
  const tickSlider = () => {
    $(".ticker").each(function () {
      const $this = $(this);
      const id = $this.attr("id");
      const tickerId = $this.data("ticker-id");
      const speedFactor = parseFloat($this.data("ticker-speed")) || 10;
      
      const swiperEl = $(`#${id} .ticker-js-${tickerId}`)[0];

      const tickerSwiper = new Swiper(swiperEl, {
        slidesPerView: "auto",
        loop: true,
        allowTouchMove: false,
        speed: 0, // We'll manually control animation speed
      });

      let animationFrame;
      let paused = false;
      const step = speedFactor / 60; // adjust speed based on ticker_speed setting

      function animate() {
        if (!paused) {
          let currentTranslate = tickerSwiper.getTranslate();
          currentTranslate -= step;
          tickerSwiper.setTranslate(currentTranslate);
        }
        animationFrame = requestAnimationFrame(animate);
      }

      // Start animation loop
      animationFrame = requestAnimationFrame(animate);

      // Pause on hover
      $this.on('mouseenter', function () {
        paused = true;
      });

      // Resume on mouse leave
      $this.on('mouseleave', function () {
        paused = false;
      });
    });
  };

  document.addEventListener("DOMContentLoaded", function () {
    tickSlider();

    document.addEventListener("shopify:section:load", function (e) {
      if (
        document
          .getElementById(`shopify-section-${e.detail.sectionId}`)
          .classList.contains("ticker")
      ) {
        tickSlider();
      }
    });
  });
})();
